import { z } from "zod";

export const autocompleteSchema = z.object({
  id: z.string(),
  summaryline: z.string(),
  locationsummary: z.string(),
});

export type AutocompleteType = z.infer<typeof autocompleteSchema>;
